<template>
    <button type="button" class="btn btn-outline-default btn-booking-number btn-block" @click="copyBookingNumber">
        <small>
            {{ 'components.bookingNumber.label' | trans }}
        </small>

        <!-- Not copied -->
        <span class="fadeIn animated" v-if="! isCopied">
            {{ bookingNumber }}
            <i class="far fa-clipboard"></i>
        </span>

        <!-- Copied -->
        <span class="fadeIn animated" v-if="isCopied">
            {{ 'components.bookingNumber.copied' | trans }}
        </span>
    </button>
</template>

<script>
    export default {
        props: ['bookingNumber'],
        data() {
            return {
                isCopied: false,
            }
        },
        mounted() {},
        computed: {},
        methods: {
            copyBookingNumber() {
                if (! this.$window.copy) {
                    return;
                }

                // Copy booking number to clipboard
                this.$window.copy(this.bookingNumber)

                this.isCopied = true

                // Reset copied status after 3 seconds
                var self = this
                setTimeout(() => {
                    self.isCopied = false
                }, 3000)
            },
        },
        watch: {}
    }
</script>
